import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const SiteSelector = ({ sites, selectedSite, onSiteChange, connectionStatus }) => {
  const siteOptions = [
    { value: 'all', label: 'All Sites' },
    ...sites?.map(site => ({
      value: site?.id,
      label: site?.name,
      description: site?.url
    }))
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'connected':
        return 'text-success';
      case 'warning':
        return 'text-warning';
      case 'disconnected':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'connected':
        return 'CheckCircle';
      case 'warning':
        return 'AlertTriangle';
      case 'disconnected':
        return 'XCircle';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="flex items-center gap-4">
      <div className="flex-1 max-w-md">
        <Select
          options={siteOptions}
          value={selectedSite}
          onChange={onSiteChange}
          searchable
          placeholder="Select WordPress site"
        />
      </div>
      
      <div className="flex items-center gap-2 px-3 py-2 bg-muted rounded-lg">
        <Icon 
          name={getStatusIcon(connectionStatus)} 
          size={16} 
          className={getStatusColor(connectionStatus)}
        />
        <span className={`text-sm font-medium ${getStatusColor(connectionStatus)}`}>
          {connectionStatus === 'connected' ? 'Connected' : 
           connectionStatus === 'warning' ? 'Limited' : 'Disconnected'}
        </span>
      </div>
    </div>
  );
};

export default SiteSelector;